import { Boxes, BadgeCheck, ShieldCheck, Headphones, Users, Lock } from "lucide-react";

const BENEFITS = [
  { icon: Boxes, title: "HVAC Equipment Specialists", text: "We focus specifically on HVAC equipment — not a general marketplace.", tone: "cool" },
  { icon: BadgeCheck, title: "Multiple Major Brands", text: "Browse equipment from several established manufacturers in one place.", tone: "cool" },
  { icon: Users, title: "Homeowners & Trade", text: "Buy quality HVAC equipment whether you're a homeowner or a professional.", tone: "warm" },
  { icon: ShieldCheck, title: "Manufacturer Warranty", text: "Equipment is covered by the applicable manufacturer warranty.", tone: "cool" },
  { icon: Headphones, title: "Direct Customer Support", text: "Talk to a real person if you need help choosing equipment.", tone: "warm" },
  { icon: Lock, title: "Secure Online Checkout", text: "Pay securely online, or arrange payment directly with us.", tone: "cool" },
];

export default function TrustSection() {
  return (
    <section className="relative overflow-hidden border-y border-slate-800 bg-[#0B1528]">
      <div className="tech-dots pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <span className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-sky-400">Why CA HVAC Direct</span>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-white sm:text-4xl">Built for Confident Equipment Buying</h2>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {BENEFITS.map((b) => {
            const Icon = b.icon;
            const warm = b.tone === "warm";
            return (
              <div key={b.title} className="rounded-lg border border-white/10 bg-white/[0.04] p-6 transition-colors duration-200 hover:border-white/20 hover:bg-white/[0.07]">
                <span className={`flex h-11 w-11 items-center justify-center rounded-sm ${warm ? "bg-orange-500/15 text-orange-400" : "bg-sky-500/15 text-sky-400"}`}>
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold tracking-tight text-white">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{b.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
